import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/redux/store';
import { questionnairesApi } from 'app/services/questionnaires';
import { resetQuestionnaire } from '../../actions';
import lodashSet from 'lodash.set';

export interface BusinessTypeStateValues {
  businessType: Nullable<string>;
  doYouHaveCopyOfYourIrsSCorpApprovalLetter: Nullable<TYesOrNo>;
  pleaseUploadACopyOfIrsSCorpApprovalLetter: Nullable<string>;
  theTaxReturnForAnLlcTaxedAsASoleProprietorshipIsFiledAsAScheduleCWithYourPersonalReturnPleaseBeAdvisedThatIfWeArePreparingYourScheduleCAndPersonalIncomeTaxReturnThisPortionWillNotBePreparedUntilYouHaveSubmittedBothYourBusinessTaxInformationAndYourPersonalTaxInformation: Nullable<string>;
}

export interface BusinessTypeState {
  values: BusinessTypeStateValues;
}

const initialState: BusinessTypeState = {
  values: {
    businessType: null,
    doYouHaveCopyOfYourIrsSCorpApprovalLetter: null,
    pleaseUploadACopyOfIrsSCorpApprovalLetter: null,
    theTaxReturnForAnLlcTaxedAsASoleProprietorshipIsFiledAsAScheduleCWithYourPersonalReturnPleaseBeAdvisedThatIfWeArePreparingYourScheduleCAndPersonalIncomeTaxReturnThisPortionWillNotBePreparedUntilYouHaveSubmittedBothYourBusinessTaxInformationAndYourPersonalTaxInformation:
      null,
  },
};

const BusinessTypeSlice = createSlice({
  name: 'BusinessType',
  initialState,
  reducers: {
    reset(state) {
      state = initialState;
    },
    update(state, action: PayloadAction<BusinessTypeStateValues>) {
      state.values = action.payload;
    },
    updateKey(
      state,
      action: PayloadAction<{
        key: keyof BusinessTypeStateValues;
        value: any;
      }>,
    ) {
      lodashSet(state, `values.${action.payload.key}`, action.payload.value);
    },

    // Update KEY_HERE_LIST if there is a Record Here
    updateFieldArrayKey(
      state: any,
      action: PayloadAction<{
        key: keyof BusinessTypeStateValues | '';
        value: any;
      }>,
    ) {
      const fieldArray = action.payload.value.map(({ ...field }) => ({
        ...field,
      }));
      if (action.payload.key === '') {
        state.values[action.payload.key] = fieldArray;
      } else {
        lodashSet(state, `values.${action.payload.key}`, fieldArray);
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetQuestionnaire, () => initialState);

    builder.addMatcher(
      questionnairesApi.endpoints.getQuestionnaireById.matchFulfilled,
      (state, { payload }) => {
        state.values = payload.questionnaire.data.taxQuestionnaire
          ? payload.questionnaire.data.taxQuestionnaire?.businessInfo
              ?.businessType?.values
          : initialState.values;
      },
    );
  },
});

export const { update, updateKey, updateFieldArrayKey } =
  BusinessTypeSlice.actions;
export default BusinessTypeSlice.reducer;

export const selectBusinessType = (state: RootState) =>
  state.taxQuestionnaire.businessInfo.businessType;
